import { getBranding, getHostConfig } from "@/branding";
import { isWebview } from "@/composables/isWebview";
import { Auth0VueClientOptions, createAuth0 } from "@auth0/auth0-vue";

const env = getHostConfig().isProductionHost ? "production" : "development";

const AUTH_DOMAIN = {
  production: "soldera-production.eu.auth0.com",
  development: "gosolid-staging.eu.auth0.com",
} as const;

const AUTH_CLIENT_ID = {
  production: {
    webview: "2eiVFqjKdrY9nQGhKAXBTLrtpY8aJO9t",
    default: "kiF6iSU49qhtaMRQgGnondazw7gpwnib",
  },
  development: {
    webview: "70Te98oFV2bLEJiP0w2odh6FhqPTTVKq",
    default: "Ren6AWSYBiIUSL8K75VAI0eN4sxq5j27",
  },
} as const;

// A white-label brand can carry its own Auth0 application on the production
// tenant; without one, the environment defaults above apply.
const brandClientId =
  env === "production" ? getBranding().productionAuthClientId : null;

export const auth0Options = {
  domain: AUTH_DOMAIN[env],
  clientId:
    brandClientId ?? AUTH_CLIENT_ID[env][isWebview() ? "webview" : "default"],
  cacheLocation: "localstorage",
  authorizationParams: {
    redirect_uri: `${window.location.origin}/callback`,
    audience: "Flask",
    ui_locales: "en",
  },
} satisfies Auth0VueClientOptions;

export const auth0 = createAuth0(auth0Options satisfies Auth0VueClientOptions);
